/* ============================================================
   AZRA · fenêtre de la lettre (maquette : home.html, bloc « fenêtre de la lettre »)
   À chaque visite (choix validé le 14/09/2026) : au premier vrai défilement (un tiers d'écran), jamais par-dessus
   le menu ouvert ni pendant la saisie dans la lettre du bas de page. Fermée ou envoyée, elle ne revient pas pendant
   le reste de la visite (sessionStorage). ?letter=1 la force pour les essais.
   L'envoi est celui du formulaire client de Shopify : la page se recharge sur ?customer_posted=true#AzraLetterPop,
   la fenêtre s'ouvre alors directement sur le remerciement.
   ============================================================ */
AZRA.onSection("letter-popup", (pop) => {
  if (typeof pop.showModal !== "function") return;
  const KEY = "azra-letter-pop";
  const form = pop.querySelector("form");
  const input = pop.querySelector('input[type="email"]');
  const msg = pop.querySelector(".lp__msg");
  const done = pop.querySelector(".lp__done");
  const later = pop.querySelector(".lp__later");
  const title = pop.querySelector(".lp__title");
  const closeBtn = pop.querySelector(".lp__close");
  const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (e) { return null; } };
  const write = (v) => { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
  const timers = [];
  const later_ = (fn, ms) => timers.push(setTimeout(fn, ms));

  const panelOpen = () => (AZRA.panelOpen ? AZRA.panelOpen() : false);
  const show = () => {
    const img = pop.querySelector("img");
    if (img) img.loading = "eager";
    document.documentElement.classList.add("lp-lock");
    pop.showModal();
    title.focus({ preventScroll: true });
  };
  const close = () => {
    if (!pop.open) return;
    write({ closedAt: Date.now() });
    if (AZRA.reduceMotion()) { pop.close(); return; }
    pop.classList.add("is-closing");
    later_(() => { pop.classList.remove("is-closing"); pop.close(); }, 440);
  };
  const showDone = () => { form.hidden = true; done.hidden = false; later.hidden = true; };

  const onClosed = () => document.documentElement.classList.remove("lp-lock");
  const onCancel = (e) => { e.preventDefault(); close(); };
  const onBackdrop = (e) => { if (e.target === pop) close(); };
  const onInput = () => { if (input.getAttribute("aria-invalid")) { input.removeAttribute("aria-invalid"); msg.textContent = ""; } };
  const onSubmit = (e) => {
    if (!input.value.trim() || !input.checkValidity()) {
      e.preventDefault();
      input.setAttribute("aria-invalid", "true");
      msg.textContent = pop.dataset.errorText;
      input.focus();
      return;
    }
    write({ submittedAt: Date.now() }); // envoi natif : la page se recharge
  };
  pop.addEventListener("close", onClosed);
  pop.addEventListener("cancel", onCancel);
  pop.addEventListener("click", onBackdrop);
  closeBtn.addEventListener("click", close);
  later.addEventListener("click", close);
  input.addEventListener("input", onInput);
  form.addEventListener("submit", onSubmit);

  const cleanup = () => {
    timers.forEach(clearTimeout);
    removeEventListener("scroll", onScrollPop);
    pop.removeEventListener("close", onClosed);
    pop.removeEventListener("cancel", onCancel);
    pop.removeEventListener("click", onBackdrop);
    closeBtn.removeEventListener("click", close);
    later.removeEventListener("click", close);
    input.removeEventListener("input", onInput);
    form.removeEventListener("submit", onSubmit);
    document.removeEventListener("shopify:section:select", onSelect);
    document.removeEventListener("shopify:section:deselect", onDeselect);
    if (pop.open) pop.close();
    onClosed();
  };

  // éditeur de thème : ouverte à la sélection de la section, fermée à la désélection
  const mine = (e) => pop.closest(".shopify-section") && pop.closest(".shopify-section").id === "shopify-section-" + e.detail.sectionId;
  const onSelect = (e) => { if (mine(e) && !pop.open) show(); };
  const onDeselect = (e) => { if (mine(e) && pop.open) pop.close(); };
  function onScrollPop() { if (scrollY > innerHeight * 0.33) later_(open, 500); }
  let armed = true;
  const open = () => {
    if (!armed || pop.open || panelOpen()) return;
    // jamais en même temps que le bandeau cookies : on attend la réponse de la visiteuse
    const cookies = document.getElementById("azra-cookies");
    if (cookies && !cookies.hidden) { later_(open, 1500); return; }
    const active = document.activeElement;
    if (active && active.closest && active.closest(".letter")) return;
    armed = false;
    removeEventListener("scroll", onScrollPop);
    show();
  };

  if (AZRA.designMode) {
    document.addEventListener("shopify:section:select", onSelect);
    document.addEventListener("shopify:section:deselect", onDeselect);
    return cleanup;
  }

  // retour de l'envoi : remerciement (ou erreur) dans la fenêtre, puis fermeture
  const posted = pop.querySelector("[data-lp-posted]");
  const failed = pop.querySelector("[data-lp-error]");
  if (location.hash === "#AzraLetterPop" && (posted || failed)) {
    if (posted) { showDone(); show(); later_(close, 2600); }
    else { show(); input.setAttribute("aria-invalid", "true"); msg.textContent = pop.dataset.errorText; }
    return cleanup;
  }

  const forced = /[?&]letter=1\b/.test(location.search);
  if (!forced && read()) return cleanup;
  addEventListener("scroll", onScrollPop, { passive: true });
  if (forced) later_(open, 900);
  return cleanup;
});
